import * as React from 'react';
import {
    MARKET_BEM as bem,
    OM_DROPDOWN_BEM as bemDropdown,
    MARKET_SELECTOR_BEM as bemMarketSelectorContent,
} from './utils/match-list.constants';
import { PlatformTypes } from '@om-fe/core/core/routing/utils';
import { FilteredMarketGroupsOverview } from './utils/match-list-models';
import { LiveMatchListStoreModel } from './containers/live-match-list/live-match-list.constants';
import { NextMatchListStoreModel } from './containers/next-match-list/next-match-list.constants';
import { FavoriteMatchListDisciplineItemStoreModel } from './containers/favorite-match-list/favorite-match-list.constants';
import { Dropdown, DropdownOption, DropdownTitle } from '@om-fe/widgets/components/dropdown';
import BottomDrawer from '@om-fe/core/components/bottom-drawer/bottom-drawer';
import { Button } from '@om-fe/widgets/dist/components/button/button';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { compose } from 'redux';

export type MatchListSliceStoreModel = LiveMatchListStoreModel
    | NextMatchListStoreModel
    | FavoriteMatchListDisciplineItemStoreModel;

export type MatchListPublicProps = {
    readonly selectGroupsOverview: (item: string) => void;
};

interface MatchListStoreProps {
    readonly filteredMarketGroupsOverviewList: string[];
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly marketSelected: string;
    readonly mainMarketsLimit: number;
    readonly isHasDrawer?: boolean;
    readonly deviceType?: PlatformTypes;
}

type MatchListProps = MatchListPublicProps & MatchListStoreProps & I18nContextInterface;

class MatchListSelectorComponent extends React.Component<MatchListProps> {
    state = {
        isDrawer: false,
    }

    handleChange = (change: string[]) => {
        const { selectGroupsOverview } = this.props;
        selectGroupsOverview(change[0]);
    }

    handleToggleMatchListSelector = () => {
        const { isDrawer } = this.state;

        this.setState({
            isDrawer: !isDrawer,
        });
    }

    handleSelectedMarket = (selected: string[]): void => {
        const { selectGroupsOverview } = this.props;
        const { isDrawer } = this.state;

        selectGroupsOverview(selected[0]);

        this.setState({
            isDrawer: !isDrawer,
        });
    }

    getMarketSelectorItem = (items: DropdownOption[], itemSelected: string | undefined) => {
        
        return  items.map((item: DropdownOption) => 
                <button onClick={() => this.handleSelectedMarket([item.value])} className={bemMarketSelectorContent({
                    element: 'Button',
                    modifiers: itemSelected === item.value ? 'Selected' : '',
                })}>
                    <span className={bemMarketSelectorContent('ButtonText')}>{item.label}</span>
                </button>
            )
    }

    render(): React.ReactNode {
        const {
            filteredMarketGroupsOverview,
            filteredMarketGroupsOverviewList,
            marketSelected,
            mainMarketsLimit,
            isHasDrawer,
            deviceType,
            gettext,
        } = this.props;
        const { isDrawer } = this.state;

        if (!filteredMarketGroupsOverview) {
            return null;
        }

        const itemSelected: string | undefined = marketSelected ? marketSelected.split(',').pop() : '';
        const itemOutOfSelected = filteredMarketGroupsOverviewList.slice(0,mainMarketsLimit-1);
        const items = filteredMarketGroupsOverviewList.length < mainMarketsLimit ? filteredMarketGroupsOverviewList.slice(-1) : filteredMarketGroupsOverviewList.filter((item) => itemOutOfSelected.indexOf(item) === -1);
        
        const options = items.map((item: string): DropdownOption => ({
            label: filteredMarketGroupsOverview[item].translatedName,
            value: filteredMarketGroupsOverview[item].id,
        }));

        if (isHasDrawer && (deviceType === 'mobile' || deviceType === 'tablet')) {
            return (
                <>
                    <div
                        className={bemDropdown({
                            extra: 'MarketSelector',
                        })}
                    >
                        <div className={bemDropdown('Header')}>
                            <Button className={bemDropdown('DropdownToggleButton')} onClick={this.handleToggleMatchListSelector}>
                                <div className={bemDropdown('Title')}>
                                    <span className={bemDropdown('SingleValue')} title={itemSelected ? filteredMarketGroupsOverview[itemSelected]?.translatedName : '' }>
                                        {itemSelected ? filteredMarketGroupsOverview[itemSelected]?.translatedName : '' }
                                    </span>
                                </div>
                                <GeneralIcon
                                    name={(isDrawer && `arr-up`) || `arr-down`}
                                    className={bemDropdown('SelectedIcon')}
                                />
                            </Button>
                        </div>
                    </div>
                    {
                        isDrawer && (
                            <BottomDrawer
                                onClose={this.handleToggleMatchListSelector}
                                title={gettext('Please select a market')}
                            >
                                <div className={bemMarketSelectorContent()}>
                                    {this.getMarketSelectorItem(options , itemSelected)}
                                </div>
                            </BottomDrawer>
                        )
                    }
                </>)
        }
        
        return (
                <Dropdown
                    className={bem()}
                    extraClassName={bem('List')}
                    placeholder={'Select Item'}
                    icon="arr-down"
                    expandedIcon="arr-up"
                    values={[itemSelected]}
                    options={options}
                    onChange={this.handleChange}
                    loading={false}
                    dropdownMinHeight={250}
                />
        );
    }
}

const MatchListSelector: React.ComponentType<MatchListProps> = compose(
    withTranslation<MatchListProps>(),
)(MatchListSelectorComponent);

export default MatchListSelector;
